import { render, staticRenderFns } from "./SalesReportNewTables.vue?vue&type=template&id=3b0b0452&scoped=true&"
import script from "./SalesReportNewTables.vue?vue&type=script&lang=ts&"
export * from "./SalesReportNewTables.vue?vue&type=script&lang=ts&"
import style0 from "./SalesReportNewTables.vue?vue&type=style&index=0&id=3b0b0452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b0452",
  null
  
)

export default component.exports